module.exports = function getSongFormOptions() {
	var opts = {
		voiceTypes: ['Soprano', 'Mezzo/Belt/Alto', 'Tenor', 'Baritone/Bass', 'Trans & Nonbinary', 'Not Applicable']
	  , ageRanges: ['Under 13', '14-17', '18-24', '25-32', '33-39', '40-59', '60+']
	    //technically the plural of 'tempo' is 'tempi' but in the code we just refer to it as 'tempos'
	  , tempos: ['Easy Ballad', 'Power Ballad', 'Medium/Moderate', 'Up-Tempo']
	  , keys: ['A', 'A♯', 'A♭', 'B', 'B♭', 'C', 'C♯', 'D', 'D♯', 'D♭', 'E', 'E♭', 'F', 'F♯', 'G', 'G♯', 'G♭']
	  , accompanistDifficulties: [1,2,3,4,5]
	  , timeSignatureNumerators: [2, 3, 4, 5, 6, 7, 9, 12]
	  , timeSignatureDenominators: [2,4,8]
	  , octaves: [2,3,4,5,6]
	  , popularity: [1,2,3,4,5]
	  , popularityLabels: [
			'',
			'Very popular',
			'Somewhat popular',
			'Heard occassionally',
			'Not heard a lot',
			'Rare find'
		]
	};

	//Decade range options (from and to)
	opts.fromDecades = [];
	var currentYear = new Date().getFullYear();

	var startDecade = 1850;
	var currentDecadeEndYear = (Math.ceil(currentYear / 10) * 10);
	if (currentDecadeEndYear==currentYear) {
		currentDecadeEndYear += 9;
	}
	else currentDecadeEndYear -= 1;

	for (var i=startDecade; i <= currentDecadeEndYear; i += 10) {
		opts.fromDecades.push(i);
	}
	opts.toDecades = [];
	opts.fromDecades.slice(1).forEach(function(decade) {
		opts.toDecades.push(decade - 1);
	});
	opts.toDecades.push(currentDecadeEndYear);

	return opts;
};
